import type { ReactNode } from "react";

interface InfoRowProps {
  icon: ReactNode;
  label: string;
  value: string;
}

/**
 * Info row component for event details.
 * Displays icon + "Label: Value" in white text with bottom border.
 */
export function InfoRow({ icon, label, value }: InfoRowProps) {
  return (
    <div className="flex items-center gap-3 border-b border-white/30 py-3 pb-4">
      <span style={{ color: "var(--color-secondary-120)" }}>{icon}</span>
      <div className="flex flex-col gap-0.5">
        <span className="text-white" style={{ fontSize: 14 }}>
          {label}: {value}
        </span>
      </div>
    </div>
  );
}
